<template>
  <div class="cmslist">
    <div class="container_wrap">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item to="/indexpc"><a>首页</a></el-breadcrumb-item>
        <el-breadcrumb-item>童演招募</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="left_and_right_container">
        <div class="container_left">
          <el-input
            placeholder="请输入姓名"
            v-model="searchdata"
            clearable
            class="container_right_search"
            prefix-icon="el-icon-search"
            @keypress.native.enter="searchFun"
          >
          </el-input>
          <el-button
            type="primary"
            round
            class="foruse_btn"
            @click="$router.push({ path: '/tongyan-apply-index' })"
            >我要申报</el-button
          >
          <div class="list_arr" v-if="newsListData.length">
            <div
              class="list_arr_item"
              v-for="(item, index) in newsListData"
              :key="index"
              @click="$router.push({name:'CuteSinglePage',query:{id:item.id}})"
            >
              <!-- src="~@/assets/images/listitem/pic-cutestar-child@2x.png" -->
              <img :src="item.pics&&item.pics.length?item.pics[0].url:''" class="list_arr_item_img" />
              <div class="list_arr_item_right">
                <div class="list_arr_item_right_namecity">
                  <div class="list_arr_item_right_namecity_name">{{item.ldname}}</div>
                  <div class="list_arr_item_right_namecity_site">{{item.province}}</div>
                </div>
                <div class="list_arr_item_right_tips">
                  <div class="list_arr_item_right_tip">
                    <p>生日:{{item.age?item.age:0}}</p>
                  </div>
                  <div class="list_arr_item_right_tip">
                    <p>身高:{{item.height?item.height:0}}cm</p>
                  </div>
                  <div class="list_arr_item_right_tip">
                    <p>体重:{{item.weight?item.weight:0}}kg</p>
                  </div>
                  <div class="list_arr_item_right_tip">
                    <p>鞋码:{{item.shoesize?item.shoesize:0}}</p>
                  </div>
                </div>
              </div>
              <div class="list_arr_item_tag" v-if="item.grade&&false">{{item.grade}}</div>
            </div>
          </div>
<img
          src="~@/assets/images/listitem/course_constuct.png"
          class="list_empty_img_class"
          v-else
        />

          <!-- <news-list-item specialTagName="推荐"></news-list-item> -->
          <!-- <news-list-item specialTagName=""></news-list-item> -->
          <!-- <news-list-item
            :specialTagName="
              item.extra_data.length > 1
                ? item.extra_data[1].value
                : item.extra_data[0].value
            "
            v-for="(item, index) in newsListData"
            :key="index"
            :NewsItemData="item"
            @click.native="itemClickFun(item)"
          ></news-list-item> -->
        </div>

        <div class="container_right">
          <CmsCrew></CmsCrew>
        </div>
      </div>
    </div>
    <DeBounce
      :fetch-fun="getTalentListFun"
      :pagefetchflag="pagefetchflag"
    ></DeBounce>
  </div>
</template>
<script>
import NewsListItem from "@/components/listItem/NewsListItem";
import DeBounce from "@/components/DeBounce";
import CmsCrew from "@/page/index/cms/CmsCrew";
export default {
  name: "TalentList",
  data() {
    return {
      searchdata: "", //搜索框model
      newsListData: [],
      // breadData: [{ name: "" }],
      pagefetchflag: true,
      listParams: {
        pageNo: 1,
        pageSize: 21,
        // cate_id: this.$route.query.id,
        status: 6,
        sort: "id",
        order: "desc",
        keywords: "",
        type: 2,
      },
    };
  },
  components: {
    NewsListItem,
    DeBounce,
    CmsCrew,
  },
  mounted() {
    // console.log(".............0",this.$store.state.breadPath)
    this.getTalentListFun();
    // if(this.$route.query.id==97){
    //   this.getStoreBread(97)
    // }else if(this.$route.query.id==115){
    //   this.getStoreBread(115)
    // }
    // this.getStoreBread(this.$route.query.id);
  },
  methods: {
    //获取面包屑的内容
    // getStoreBread(cate_id) {
    //   var that = this;
    //   that.$api.get(
    //     "/api/cms/breadList",
    //     {
    //       cate_id: cate_id,
    //     },
    //     (res) => {
    //       that.breadData = res.data;
    //       that.breadData.some((item) => {
    //         if (item.url) {
    //           item.url = eval("(" + item.url + ")");
    //         }
    //       });
    //     },
    //     (r) => {
    //       that.$message.error(r.msg);
    //     }
    //   );
    // },
    //新闻条点击事件
    itemClickFun(val) {
      this.$router.push({ path: "/cmsdetail", query: { id: val.id } });
    },
    searchFun() {
      // if (this.searchdata.trim() == "") {
      //   this.$message({ type: "error", message: "搜索内容为空！" });
      //   return;
      // }
      this.listParams.keywords = this.searchdata;
      this.listParams.pageNo = 1;
      this.pagefetchflag = true;
      this.newsListData = [];
      this.getTalentListFun();
      // this.$message({ type: "success", message: "查询成功" });
    },
    //获取新闻列表
    getNewsItemlist() {
      const that = this;
      that.$api.get(
        "/api/cms/helpList",
        this.listParams,
        (res) => {
          if (this.listParams.pageNo == 1) {
            that.newsListData = res.data.list;
          } else {
            if (
              res.data.list &&
              res.data.list.length < this.listParams.pageSize
            ) {
              this.pagefetchflag = false;
              // this.$message.success("已加载全部！");
            }
            that.newsListData = that.newsListData.concat(res.data.list);
          }
          if (this.pagefetchflag) {
            this.listParams.pageNo += 1;
          }
        },
        (r) => {
          that.$message.error(r.msg);
        }
      );
    },
    getTalentListFun() {
      var that = this;
      this.$api.get(
        "/api/cms/cuteStarapplyList",
        this.listParams,
        (res) => {
          if (this.listParams.pageNo == 1) {
            that.newsListData = res.data.list;
          } else {
            if (
              res.data.list &&
              res.data.list.length < this.listParams.pageSize
            ) {
              this.pagefetchflag = false;
              // this.$message.success("已加载全部！");
            }
            that.newsListData = that.newsListData.concat(res.data.list);
          }
          if (this.pagefetchflag) {
            this.listParams.pageNo += 1;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
  watch: {
    $route: {
      handler() {
        this.listParams.pageNo = 1;
        // this.listParams.cate_id = this.$route.query.id;
        this.listParams.keywords = "";
        this.pagefetchflag = true;
        this.getTalentListFun();
        // console.log("this.$route.",this.$route.query.id);
        // this.getCateTargetFun();
        // if (this.$route.query.id == 97) {
        //   this.getStoreBread(97);
        // } else if (this.$route.query.id == 115) {
        //   this.getStoreBread(115);
        // }
        // this.getStoreBread(this.$route.query.id);
      },
      deep: true,
    },
  },
};
</script>
<style scoped lang="scss">
.cmslist {
  width: 100%;
  background: #f4faff;
  height: 100%;
  overflow: hidden;
  padding-bottom: 50px;
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
  // height: 1235px;
}
.breadcrumb {
  margin-top: 21px;
  margin-left: 23px;
  margin: 21px 0 20px 23px;
}
.left_and_right_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .container_left {
    width: 910px;
    min-height: 1142px;
    // background: #ffffff;
    // box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
    // border-radius: 40px;
    padding: 16px 0 0 0;
    box-sizing: border-box;
    .foruse_btn {
      float: right;
    }
    .container_right_search {
      width: 308px;
      height: 44px;
      margin-bottom: 11px;
      /deep/.el-input__inner {
        height: 44px;
        border-radius: 22px;
      }
    }
    .list_arr {
      width: 100%;
      font-size: 0;
      margin-top: 28px;
      .list_arr_item {
        width: 298px;
        height: 128px;
        background: #ffffff;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
        border-radius: 16px;
        box-sizing: border-box;
        display: inline-flex;
        margin-right: 8px;
        margin-bottom: 45px;
        transition: all 0.3s;
        position: relative;
        &:nth-child(3n) {
          margin-right: 0;
        }
        &:hover {
          cursor: pointer;
          transform: scale(1.03);
        }
        .list_arr_item_img {
          width: 100px;
          height: 120px;
          object-fit: cover;
          border-radius: 12px;
          overflow: hidden;
          margin: -15px 14px 0 8px;
        }
        .list_arr_item_right {
          flex: 1;
          .list_arr_item_right_namecity {
            display: flex;
            flex-direction: row;
            align-items: center;
            box-sizing: border-box;
            padding-bottom: 2px;
            .list_arr_item_right_namecity_name {
              min-width: 48px;
              max-width: 55px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              height: 32px;
              font-size: 16px;
              font-weight: 500;
              color: #000000;
              line-height: 32px;
              margin-right: 8px;
            }
            .list_arr_item_right_namecity_site {
              min-width: 24px;
              max-width: 55px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              height: 17px;
              font-size: 12px;
              font-weight: 400;
              color: #999999;
              line-height: 17px;
            }
          }
          .list_arr_item_right_tips {
            width: 170px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            .list_arr_item_right_tip {
              flex: 50%;
              font-size: 12px;
              font-weight: 400;
              color: #666666;
              line-height: 17px;
              display: flex;
              flex-direction: row;
              align-items: center;
              margin-top: 16px;
              overflow: hidden;
              p {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              &::before {
                content: "";
                flex-shrink: 0;
                display: block;
                width: 11px;
                height: 13px;
                background: url("~@/assets/images/listitem/icon-zhishibiaoshi@2x.png")
                  center center no-repeat;
                background-size: 100% 100%;
                margin-right: 2px;
              }
            }
          }
        }

        .list_arr_item_tag {
          width: 63px;
          max-width: 63px;
          height: 22px;
          text-align: center;
          line-height: 22px;
          background: url("~@/assets/images/listitem/icon-tag@2x.png") center
            center no-repeat;
          background-size: 100% 100%;
          position: absolute;
          right: 0;
          top: 0;
          font-size: 12px;
          font-weight: 500;
          color: #ffffff;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .container_right {
    width: 306px;
  }
}
</style>


// WEBPACK FOOTER //
// TalentList.vue?efc8a288